import { render, staticRenderFns } from "./ThreeDotsIcon.vue?vue&type=template&id=09d2c1d6&scoped=true&"
import script from "./ThreeDotsIcon.vue?vue&type=script&lang=js&"
export * from "./ThreeDotsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d2c1d6",
  null
  
)

export default component.exports